const override = false;
const config = {
    development: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        FUNNEL_SUB_DOMAIN_URL: 'staging.sites.ludicrous.cloud',
        CLIENT_PORTAL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        CLIENT_PORTAL_SUB_DOMAIN_URL: 'staging.clientportal.ludicrous.cloud',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'staging.brand.ludicrous.cloud',
        WHITELABEL_APP_SUB_DOMAIN_URL: 'staging.whitelabel.ludicrous.cloud',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'staging.brand.ludicrous.cloud',
        DOMAIN_CONNECT_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/email-isv',
        mode: 'development',
    },
    staging: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        FUNNEL_SUB_DOMAIN_URL: 'staging.sites.ludicrous.cloud',
        CLIENT_PORTAL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        CLIENT_PORTAL_SUB_DOMAIN_URL: 'staging.clientportal.ludicrous.cloud',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'staging.brand.ludicrous.cloud',
        WHITELABEL_APP_SUB_DOMAIN_URL: 'staging.whitelabel.ludicrous.cloud',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'staging.brand.ludicrous.cloud',
        DOMAIN_CONNECT_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/email-isv',
        mode: 'staging',
    },
    beta: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        FUNNEL_SUB_DOMAIN_URL: 'sites.ludicrous.cloud',
        CLIENT_PORTAL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        CLIENT_PORTAL_SUB_DOMAIN_URL: 'clientportal.ludicrous.cloud',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'brand.ludicrous.cloud',
        WHITELABEL_APP_SUB_DOMAIN_URL: 'whitelabel.ludicrous.cloud',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'brand.ludicrous.cloud',
        DOMAIN_CONNECT_SERVICE_URL: 'https://services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://services.leadconnectorhq.com/email-isv',
        mode: 'beta',
    },
    production: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        FUNNEL_SUB_DOMAIN_URL: 'sites.ludicrous.cloud',
        CLIENT_PORTAL_ROOT_DOMAIN_IP_ADDRESS: '162.159.140.166',
        CLIENT_PORTAL_SUB_DOMAIN_URL: 'clientportal.ludicrous.cloud',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'brand.ludicrous.cloud',
        WHITELABEL_APP_SUB_DOMAIN_URL: 'whitelabel.ludicrous.cloud',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'brand.ludicrous.cloud',
        DOMAIN_CONNECT_SERVICE_URL: 'https://services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://services.leadconnectorhq.com/email-isv',
        mode: 'production',
    },
};
if (override) {
    // do overrides here
    // config.development.DOMAIN_CONNECT_SERVICE_URL =
    //   'http://localhost:6050/domain-connect'
}
export default config[process.env.mode];
